import { POSTHOG_HOST, POSTHOG_KEY, POSTHOG_UI_HOST } from "../constants.ts";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { getCurrentUserEmail } from "../utils/tokenUtils.ts";
import { useEffect } from "react";

const PostHogWrapper = ({ children }: { children: React.ReactNode }) => {
  const email = getCurrentUserEmail();

  useEffect(() => {
    if (window.location.hostname === "localhost") {
      return;
    }

    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      ui_host: POSTHOG_UI_HOST
    });

    if (email) {
      posthog.identify(email, { email });
    }
  }, [email]);

  if (window.location.hostname === "localhost") {
    return <>{children}</>;
  }

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
};

export default PostHogWrapper;
